import React, {useMemo, useState} from "react";
import {useLang} from "./Metronici18n";
import {IntlProvider} from "react-intl";
import axios from "axios";
import "@formatjs/intl-relativetimeformat/polyfill";
import "@formatjs/intl-relativetimeformat/dist/locale-data/en";
import "@formatjs/intl-relativetimeformat/dist/locale-data/es";

export function I18nProvider({ children }) {
  const locale = useLang();
  const [messages, setMessages] = useState({});
  useMemo(() =>{
    const fetchMessages = async () => {
      const result = await axios.get(`${process.env.REACT_APP_API_URL}/translations/${locale}`);
      setMessages(result.data);
    }
    fetchMessages();
  }, [locale]);
  return (
    <IntlProvider defaultLocale={locale} locale={locale} key={locale} messages={messages}>
      {children}
    </IntlProvider>
  );
}

